import { useEffect, useState } from "react";
import type { ForteXApi } from "@fortex/api";

export function MasterDataIcon({ api, idName, hasIcon }: { api: ForteXApi; idName: string; hasIcon: boolean }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!hasIcon) {
      setUrl(null);
      return;
    }

    let active = true;

    api.typeIcon(idName).then(result => {
      if (active) setUrl(result);
    });

    return () => {
      active = false;
    };
  }, [api, idName, hasIcon]);

  if (url === null) return <span className="fxapp-icon-cell fxapp-icon-cell-empty" aria-hidden="true" />;

  return <img className="fxapp-icon-cell" src={url} alt="" />;
}
